import { gameAssetUrl } from "../../config/assets";
import axios from "../api";
export async function getSbcs(setId, platform) {
    const res = await axios.get(`/sbcs?setId=${setId}`);
    return res.data.map((sbc) => ({
        ...sbc,
        setId: setId,
        solvable: true,
        restricted: false,
        reward: sbc.rewards?.[0],
        isCompleted: sbc.solved,
        price: platform === "Playstation" ? sbc.psPrice : sbc.pcPrice,
        imageURL: res.data.length === 1
            ? gameAssetUrl(`sbcs/sets/icons/${setId}.png`)
            : sbc.imageURL,
    }));
}
//# sourceMappingURL=getSbcs.js.map